import {type WasTrendScore} from '../../../values/was-trend-score/WasTrendScore'

export interface WasTrendReduxState {
    isFetchingLast12H: boolean
    isFetchingLast24H: boolean
    isFetchingLast7D: boolean
    isFetchingLast30D: boolean
    isFetchingLast90D: boolean
    trendLast12H: WasTrendScore[]
    trendLast24H: WasTrendScore[]
    trendLast7D: WasTrendScore[]
    trendLast30D: WasTrendScore[]
    trendLast90D: WasTrendScore[]
}

export const DEFAULT_WAS_TREND_STATE: WasTrendReduxState = {
    isFetchingLast12H: true,
    isFetchingLast24H: true,
    isFetchingLast7D: true,
    isFetchingLast30D: true,
    isFetchingLast90D: true,
    trendLast12H: [],
    trendLast24H: [],
    trendLast7D: [],
    trendLast30D: [],
    trendLast90D: [],
}
